<template>
    <div>
        <div v-if="loading">
            <bouncing-component></bouncing-component>
        </div>
        <div v-else>
            <render-index-table v-if="reports.length > 0" :reports="reports"></render-index-table>
            <div v-else class="text-center">
                <em>There isn't a report using this query</em>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import RenderIndexTable from '../reports/RenderIndexTable.vue';
    import BouncingComponent from '../../components/Bouncing-loader.vue';
    export default {
        components: {
            RenderIndexTable,
            BouncingComponent
        },
        props: {
            query_id: {
                required: true
            }
        },
        data() {
            return {
                loading: true
            }
        },
        computed: {
            ...mapState('queries', {
                reports: 'reports'
            })
        },
        created() {
            this.loading = true;
            this.$store.dispatch('queries/fetchReports', this.query_id).then(() => {
                this.loading = false;
            });
            this.unwatch = this.$store.watch(
				(state)=>
					this.$store.state.organizationSelected
				,
				(newValue, oldValue)=>{
					this.$store.dispatch('queries/setInitialStatus');
					this.$store.dispatch('clearMessages');
					this.$router.replace({ name: 'query.create' });
				},
			);
        },
        beforeDestroy() {
            this.$store.commit('queries/SET_REPORTS', []);
        },
    }
</script>
